import { ColDef } from "@ag-grid-community/core";
import { createSelector } from "reselect";

import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

import { RootState } from "@app/store/rootReducer";
import CHECKBOX_COLUMN_DEF from "@app/util/fieldModel/checkBoxColumnDef";

const peopleState = (state: RootState) => state.scene.people;

export const getGridColumnDefs = createSelector(
  [peopleState, (_, forClientSideGrid?: boolean) => forClientSideGrid],
  ({ columns }, forClientSideGrid) => {
    // get field's gridProperties && also add width/pinned/hide props from the column model
    const columnDefs = columns
      .filter(({ field }) => field.isReadable || field.isSystemRequired)
      .map<ColDef>(({ field, pinned, visible, width }) => ({
        ...(field.gridProperties(forClientSideGrid) ?? {}),
        hide: !visible,
        pinned,
        width,
      }));

    // always make a checkbox column to appear on the left side of a grid
    columnDefs.unshift(CHECKBOX_COLUMN_DEF);

    return columnDefs;
  }
);

export const getListViewState = createSelector(
  peopleState,
  ({ columns, filter, range, selectedSavedFilterId, sort }): ViewState => ({
    columns,
    filter,
    range,
    selectedSavedFilterId,
    sort,
  })
);

export const isLoading = createSelector(peopleState, ({ loading }) => loading);

export const getTotalFilteredRecordsCount = createSelector(
  peopleState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getTotalRecordsCount = createSelector(peopleState, ({ totalRecords }) => totalRecords);

export const getOfferedFilters = createSelector(peopleState, ({ offerFilters }) => offerFilters);
